(function () {
  function getColorMap() {
    var el = document.querySelector('[data-favorist-color-photo-map]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function extractFilename(src) {
    if (!src) return null;
    try {
      var clean = src.split('?')[0];
      var last = clean.split('/').pop();
      var noExt = last.split('.')[0];
      return noExt;
    } catch (e) {
      return null;
    }
  }

  function selectColor(colorValue) {
    var pickers = document.querySelectorAll('variant-picker');
    for (var p = 0; p < pickers.length; p++) {
      var inputs = pickers[p].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        var input = inputs[j];
        if (input.value === colorValue) {
          if (!input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
    }
    return false;
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var gallery = target.closest('media-gallery');
    if (!gallery) return;

    var imgHolder = target.closest('.slideshow-controls__thumbnail, slideshow-slide, .product-media-container');
    var img = null;
    if (imgHolder) img = imgHolder.querySelector('img');
    if (!img) img = target.closest('img');
    if (!img) return;

    var map = getColorMap();
    if (!map) return;

    var key = extractFilename(img.currentSrc || img.src);
    if (!key || !(key in map)) return;

    selectColor(map[key]);
  }

  document.addEventListener('click', handleClick, true);
})();
